import React, { useEffect, useState } from 'react';
// Tabel mapping manual Impact -> Service team.
// Laporan bulanan dikelompokkan per service team, sedangkan Solman hanya punya
// kolom Impact berisi teks bebas. Mapping disimpan di tabel solman_team_map
// dan dibaca langsung oleh monthlyReport.
const LS_KEYS = ['auth_token', 'token', 'authToken', 'jwt', 'access_token'];
function getToken() {
  let t = new URLSearchParams(window.location.search).get('token');
  if (!t) for (const k of LS_KEYS) { const v = localStorage.getItem(k); if (v && v.length > 20) { t = v; break; } }
  if (!t) for (const k of LS_KEYS) { const v = sessionStorage.getItem(k); if (v && v.length > 20) { t = v; break; } }
  return t || '';
}
const TH = { textAlign: 'left', padding: 8, borderBottom: '1px solid #e5e7eb', fontSize: 12, color: '#6b7280' };
const TD = { padding: 8, borderBottom: '1px solid #f3f4f6' };
const BTN = { padding: '6px 14px', borderRadius: 8, cursor: 'pointer', border: '1px solid #d1d5db', background: '#fff' };
export default function ImpactTeamMap() {
  const [rows, setRows] = useState([]);
  const [status, setStatus] = useState('loading');
  const [msg, setMsg] = useState('');
  const API_BASE = window.__API_BASE__ || '';
  const auth = () => ({ Authorization: `Bearer ${getToken()}` });
  const load = async () => {
    setStatus('loading'); setMsg('');
    try {
      const r = await fetch(`${API_BASE}/api/solman/team-map`, { headers: auth() });
      const j = await r.json();
      if (!j.ok) throw new Error(j.error || 'gagal memuat');
      setRows(j.rows || []); setStatus('ready');
    } catch (e) { setStatus('error'); setMsg(e.message); }
  };
  useEffect(() => { load(); }, []); // eslint-disable-line
  const save = async () => {
    setStatus('saving'); setMsg('');
    try {
      const body = { rows: rows.map((x) => ({ impact: x.impact, service_team: x.service_team || '' })) };
      const r = await fetch(`${API_BASE}/api/solman/team-map`, { method: 'PUT',
        headers: Object.assign({ 'Content-Type': 'application/json' }, auth()),
        body: JSON.stringify(body) });
      const j = await r.json();
      if (!j.ok) throw new Error(j.error || 'gagal menyimpan');
      setStatus('ready'); setMsg('Tersimpan. Laporan bulanan berikutnya memakai mapping ini.');
    } catch (e) { setStatus('error'); setMsg(e.message); }
  };
  const setTeam = (impact, v) => setRows((old) => old.map((x) => (x.impact === impact ? Object.assign({}, x, { service_team: v }) : x)));
  return (
    <div style={{ border: '1px solid #e5e7eb', borderRadius: 12, padding: 16, marginTop: 16, background: '#fff' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 6 }}>
        <b style={{ fontSize: 14 }}>Mapping Impact -&gt; Service team</b>
        <button style={BTN} onClick={save} disabled={status === 'saving'}>Simpan</button>
        <button style={BTN} onClick={load}>Muat ulang</button>
        <span style={{ fontSize: 12, color: status === 'error' ? '#b91c1c' : '#6b7280' }}>
          {status === 'loading' ? 'memuat...' : (status === 'saving' ? 'menyimpan...' : msg)}</span>
      </div>
      <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 10 }}>
        Dipakai laporan bulanan untuk tabel By service team. Impact yang dibiarkan kosong tetap tampil memakai nilai aslinya.
      </div>
      <div style={{ maxHeight: 360, overflow: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead><tr>
            <th style={TH}>Impact</th>
            <th style={Object.assign({}, TH, { textAlign: 'right' })}>Tiket</th>
            <th style={TH}>Service team</th>
          </tr></thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.impact}>
                <td style={TD}>{r.impact}</td>
                <td style={Object.assign({}, TD, { textAlign: 'right' })}>{r.tickets}</td>
                <td style={TD}>
                  <input value={r.service_team || ''} onChange={(e) => setTeam(r.impact, e.target.value)}
                    placeholder="mis. PP / SD / PM / FICO / ABAP"
                    style={{ width: '100%', padding: '5px 8px', border: '1px solid #d1d5db', borderRadius: 6 }} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
